import type { MouseEvent, ReactNode } from "react";
import { tv } from "tailwind-variants";

import { Tooltip } from "./tooltip";
import { useCopyValueToClipboard } from "./use-copy-value-to-clipboard";

const copyableValueVariants = tv({
  base: [
    "-mx-1 inline-block max-w-full cursor-pointer truncate rounded px-1 text-left align-middle",
    "border-b border-dashed border-line-control",
    "transition-colors duration-150 hover:border-solid hover:bg-surface-active hover:text-content-strong",
    "focus:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring focus-visible:outline-none",
  ],
});

type CopyableValueProps = {
  announcedValue?: string;
  children?: ReactNode;
  label: string;
  value: string;
};

export const CopyableValue = ({ announcedValue, children, label, value }: CopyableValueProps) => {
  const copyValueToClipboard = useCopyValueToClipboard();

  const fieldName = label.toLowerCase();

  const handleCopy = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    void copyValueToClipboard(value, label);
  };

  return (
    <Tooltip content={`Click to copy ${fieldName}`} anchorOnChild>
      <button
        aria-label={`Copy ${fieldName} for ${announcedValue ?? value}`}
        className={copyableValueVariants()}
        onClick={handleCopy}
        type="button"
      >
        {children ?? value}
      </button>
    </Tooltip>
  );
};
